"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AceRouter = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var lodash_omit_1 = __importDefault(require("lodash.omit"));
var renderRoutes_1 = require("./renderRoutes");
var util_1 = require("./util");
var Routes = function (props) { return renderRoutes_1.renderRoutes(__assign({}, props)); };
// eslint-disable-next-line max-lines-per-function
function AceRouter(routerProps) {
    var _a = routerProps.routes, routes = _a === void 0 ? [] : _a, lazy = routerProps.lazy, isBrowser = routerProps.isBrowser, App = routerProps.App, Page = routerProps.Page, history = routerProps.history, _initProps = routerProps.initialProps, basename = routerProps.basename, disableRouterGetInitialProps = routerProps.disableRouterGetInitialProps, isSSG = routerProps.isSSG, isSSR = routerProps.isSSR, additionalProps = routerProps.additionalProps;
    var _location = _initProps._location, _b = _initProps.app, app = _b === void 0 ? {} : _b, _c = _initProps.pageProps, pageProps = _c === void 0 ? {} : _c, initialProps = __rest(_initProps, ["_location", "app", "pageProps"]);
    // SSG 只支持 App.getStaticProps
    var appInitialProps = isSSG ? _initProps : app;
    if (Page) {
        appInitialProps = __assign(__assign(__assign({}, appInitialProps), { pageProps: pageProps }), initialProps);
    }
    var parsedRoutes = !isSSR ?
        routes :
        react_1.useMemo(function () {
            /* eslint-disable-next-line no-shadow */
            return (function _parsedRoutes(rawRoutes) {
                /* eslint-disable-next-line no-shadow */
                return rawRoutes.map(function (_a) {
                    var RouteComponent = _a.component, innerRoutes = _a.routes, id = _a.id, exact = _a.exact, others = __rest(_a, ["component", "routes", "id", "exact"]);
                    var _routes;
                    if (innerRoutes && innerRoutes.length) {
                        _routes = _parsedRoutes(innerRoutes);
                    }
                    var _initialProps = {};
                    if (initialProps[id] && exact) {
                        _initialProps = initialProps[id];
                        appInitialProps = __assign(__assign({}, appInitialProps), { pageProps: initialProps[id] });
                    }
                    if (!exact) {
                        _initialProps = __assign(__assign({}, initialProps[id]), { pageProps: Object.values(lodash_omit_1.default(initialProps, [id]))[0] || {} });
                    }
                    var component = function (props) { return react_1.default.createElement(RouteComponent, __assign({}, _initialProps, props)); };
                    component.getInitialProps = RouteComponent === null || RouteComponent === void 0 ? void 0 : RouteComponent.getInitialProps;
                    component.originComponent = RouteComponent;
                    return __assign({ component: component, routes: _routes, exact: exact }, others);
                });
            })(routes);
        }, [routes, initialProps]);
    // change title when router change
    var listen = history.listen;
    react_1.useEffect(function () {
        util_1.setDocumentTitle(routerProps, true);
        listen(function () {
            util_1.setDocumentTitle(routerProps, false);
        });
    }, [routerProps]);
    var RoutesComponent = function () { return (react_1.default.createElement(Routes, { routes: parsedRoutes, lazy: lazy, isBrowser: isBrowser, disableRouterGetInitialProps: disableRouterGetInitialProps, isSSR: isSSR })); };
    // for SSR MPA
    var NoRoutesComponent = function () { return react_1.default.createElement(Page, __assign({}, initialProps, pageProps)); };
    if (isBrowser) {
        return (react_1.default.createElement(react_router_dom_1.Router, { history: history },
            react_1.default.createElement(App, __assign({}, appInitialProps, additionalProps, { Component: Page ? NoRoutesComponent : RoutesComponent, history: history }),
                react_1.default.createElement(Routes, { routes: parsedRoutes, lazy: lazy, isBrowser: isBrowser, disableRouterGetInitialProps: disableRouterGetInitialProps, isSSR: isSSR }))));
    }
    return (react_1.default.createElement(react_router_dom_1.StaticRouter, { location: _location, basename: basename },
        react_1.default.createElement(App, __assign({}, appInitialProps, { Component: Page ? NoRoutesComponent : RoutesComponent, history: history }),
            react_1.default.createElement(Routes, { routes: parsedRoutes }))));
}
exports.AceRouter = AceRouter;
//# sourceMappingURL=Router.js.map